import React from "react";
import cs from "classnames";

import roomPanelImage from "../../assets/images/RoomDevice-3D.webp";
import sensorImage from "../../assets/images/workspace occupancy sensor.webp";
import mediaPlayerImage from "../../assets/images/mediaplayer_transp.webp";
import operatingSystemImage from "../../assets/images/operating system.webp";
import floorMapImage from "../../assets/images/2d:3d floor map artwork.webp";
import crossOrgImage from "../../assets/images/cross-org shared calendars.webp";
import totalCareImage from "../../assets/images/total-care-support.webp";

import { Icon } from "../shared/Icon/Icon";
import { ProductStoreArtwork as ArtworkType } from "./ProductStore.types";

import "./ProductStoreArtwork.scss";

interface Props {
  artwork: ArtworkType;
  alt: string;
}

const IMAGE_ARTWORK: Partial<Record<ArtworkType, string>> = {
  "room-panel": roomPanelImage,
  "sensor-one": sensorImage,
  "floor-map": floorMapImage,
  "cross-org": crossOrgImage,
  "total-care": totalCareImage,
};

const ShieldArtwork = ({ premium }: { premium?: boolean }) => (
  <Icon
    icon="shield-icon"
    className={cs("ProductStoreArtwork__shield", {
      "ProductStoreArtwork__shield--premium": premium,
    })}
  />
);

const MediaPlayerArtwork = () => (
  <div className="ProductStoreArtwork__mediaPlayer">
    <img
      className="ProductStoreArtwork__mediaPlayerOs"
      src={operatingSystemImage}
      alt=""
    />
    <span aria-hidden="true">→</span>
    <img
      className="ProductStoreArtwork__mediaPlayerDevice"
      src={mediaPlayerImage}
      alt=""
    />
  </div>
);

const SensorFourPackArtwork = () => (
  <div className="ProductStoreArtwork__sensorGrid">
    {Array.from({ length: 4 }, (_, index) => (
      <img key={index} src={sensorImage} alt="" />
    ))}
  </div>
);

const RoomPanelSensorArtwork = () => (
  <div className="ProductStoreArtwork__roomPanelSensor">
    <img
      className="ProductStoreArtwork__roomPanelSensorPanel"
      src={roomPanelImage}
      alt=""
    />
    <img
      className="ProductStoreArtwork__roomPanelSensorSensor"
      src={sensorImage}
      alt=""
    />
  </div>
);

export const ProductStoreArtwork = ({ artwork, alt }: Props) => {
  const image = IMAGE_ARTWORK[artwork];

  if (image) {
    return (
      <img
        className={cs("ProductStoreArtwork__image", {
          "ProductStoreArtwork__image--fullBleed":
            artwork === "cross-org" || artwork === "total-care",
          "ProductStoreArtwork__image--floorMap": artwork === "floor-map",
        })}
        src={image}
        alt={alt}
      />
    );
  }

  return (
    <div
      className={cs("ProductStoreArtwork__vector", {
        "ProductStoreArtwork__vector--composite":
          artwork === "room-panel-sensor",
      })}
      role="img"
      aria-label={alt}
    >
      {artwork === "extended-care" && <ShieldArtwork />}
      {artwork === "premium-care" && <ShieldArtwork premium />}
      {artwork === "room-panel-sensor" && <RoomPanelSensorArtwork />}
      {artwork === "sensor-four" && <SensorFourPackArtwork />}
      {artwork === "media-player" && <MediaPlayerArtwork />}
    </div>
  );
};
